import { Org, OrgsFilterParams } from 'api/Orgs/types';
import TableTopPanel from 'app/common_components/TableTopPanel/TableTopPanel';
import 'components/Dashboard/Orgs/Orgs.css';
import usePaginationParams from 'app/hooks/usePaginationParams';
import OrgsFilter from 'components/Dashboard/Orgs/OrgsFilter/OrgsFilter';
import { DashboardPageProps } from 'components/Dashboard/types';
import { ORG_ID_NEW } from 'components/Dashboard/Orgs/consts';
import { useColumns, useOrgs } from 'components/Dashboard/Orgs/hooks';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Orgs: React.FC<DashboardPageProps> = ({ setTitle }) => {
  const { columns, goToEditOrg } = useColumns();
  const { fetchOrgs, isLoading, response } = useOrgs();
  const navigate = useNavigate();
  const goToCreateOrg = () => navigate(ORG_ID_NEW);
  const { modelParam, modelApiParam } = usePaginationParams();

  const getFilter = useCallback((): OrgsFilterParams => ({
    model: modelParam,
    modelApi: modelApiParam,
  }), [ modelParam, modelApiParam ]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchOrgs(getFilter(), abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchOrgs, getFilter ]);

  useEffect(() => {
    setTitle('Organizations');
  }, [ setTitle ]);

  return (
    <>
      <TableTopPanel
        RightColumn={<Button type="primary" onClick={goToCreateOrg} icon={<PlusOutlined />}>Add organization</Button>}
        Filter={OrgsFilter}
      />

      <Table
        rowKey={(org: Org) => org.id}
        columns={columns}
        dataSource={response}
        scroll={{ x: true }}
        pagination={false}
        loading={isLoading}
        onRow={record => ({
          onClick: () => goToEditOrg(record.id),
        })}
        rowClassName="orgRow"
      />
    </>
  );
};

export default Orgs;
